import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Link} from 'react-router-dom';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';

import ActionTemplate from './ActionTemplate';

import {
  Person,
  PowerSettingsNew,
} from '../../icons/index';

import {ROUTES} from '../../constants';

import style from './style';

class ProfileHeaderAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleClick = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleClose = () => {
    this.setState({isOpen: false});
  };

  render() {
    const {
      classes,
      logout,
      loggedAccount,
    } = this.props;
    const {isOpen} = this.state;

    return (
      <ActionTemplate
        actionName={I18n.t('headerUser.accountOption.name')}
        classes={classes}
        handleClick={this.handleClick}
        handleClose={this.handleClose}
        icon={<Person className={classes.links} />}
        isOpen={isOpen}
      >
        <Paper className={classes.dropdown}>
          <div
            className={classNames(
              classes.dropdown__header,
              classes.dropdown__header_profile,
            )}
          >
            {loggedAccount.email}
          </div>
          <MenuList
            className={classes.action__menuList}
            role="menu"
          >
            <Link
              to={ROUTES.PROFILE}
              href={ROUTES.DEFAULT}
              onClick={this.handleClose}
            >
              <MenuItem className={classes.dropdown__item}>
                <Person className={classes.dropdownItem__icon} />
                {I18n.t('headerUser.accountOption.profile')}
              </MenuItem>
            </Link>
            <MenuItem
              className={classes.dropdown__item}
              onClick={logout}
            >
              <PowerSettingsNew className={classes.dropdownItem__icon} />
              {I18n.t('headerUser.accountOption.logout')}
            </MenuItem>
          </MenuList>
        </Paper>
      </ActionTemplate>
    );
  }
}

ProfileHeaderAction.propTypes = {
  classes: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  loggedAccount: PropTypes.object.isRequired,
};

export default withStyles(style)(ProfileHeaderAction);
